// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
   overflow: hidden;
}
.folders {
   list-style: none;
   margin: 0;
   padding: 0;
}
li {
   margin-top: 8px;
   position: relative;
}
a {
   color: #666;
   cursor: pointer;
   display: inline-block;
   line-height: 20px;
   margin-left: 45px;
   padding-right: 5px;
   position: relative;
   word-break: break-all;
}
a:hover {
   color: #ffa726;
}
i {
   display: block;
   line-height: 20px;
   width: 20px;
   height: 20px;
   text-align: center;
   transition: transform .3s;
   position: absolute;
   top: 0;
   left: 0;
}
i.fa-spinner {
   left: -1px;
}
img {
   display: block;
   width: 20px;
   height: 20px;
   position: absolute;
   top: 0;
   left: -25px;
}
.expanded {
   transform: rotate(90deg);
}
.error {
   margin-left: 8px;
   margin-top: 5px;
}

app-folders,
app-one-drive-folders,
app-google-drive-folders,
app-dropbox-folders{
   display: block;
   margin-left: 16px;
}

a.selectedPath {
   color: #00bed6;
}
a.denied {
   cursor: default;
   color: #a7a6a6;
   text-decoration: none;
}
.denied img {
   filter: grayscale(100%);
   opacity: .8;
}
.cannot{
   color: #a7a6a6;
   cursor:default;
   text-decoration:none;
}
.cannot:hover{
   color: #a7a6a6!important;
   text-decoration:none;
}
.marginFolder{
   margin-left:20px!important;
}
.checkBox{
   width: 5px;
   margin-left: 5px
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/folders/folders.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;AACnB;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;GACf,kBAAkB;AACrB;AACA;GACG,WAAW;GACX,eAAe;GACf,qBAAqB;GACrB,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;GAClB,qBAAqB;AACxB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;GACd,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,yBAAyB;GACzB,kBAAkB;GAClB,MAAM;GACN,OAAO;AACV;AACA;GACG,UAAU;AACb;AACA;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,MAAM;GACN,WAAW;AACd;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,gBAAgB;GAChB,eAAe;AAClB;;AAEA;;;;GAIG,cAAc;GACd,iBAAiB;AACpB;;AAEA;GACG,cAAc;AACjB;AACA;GACG,eAAe;GACf,cAAc;GACd,qBAAqB;AACxB;AACA;GACG,uBAAuB;GACvB,WAAW;AACd;AACA;GACG,cAAc;GACd,cAAc;GACd,oBAAoB;AACvB;AACA;GACG,wBAAwB;GACxB,oBAAoB;AACvB;AACA;GACG,0BAA0B;AAC7B;AACA;GACG,UAAU;GACV;AACH","sourcesContent":[".container {\n   overflow: hidden;\n}\n.folders {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\nli {\n   margin-top: 8px;\n   position: relative;\n}\na {\n   color: #666;\n   cursor: pointer;\n   display: inline-block;\n   line-height: 20px;\n   margin-left: 45px;\n   padding-right: 5px;\n   position: relative;\n   word-break: break-all;\n}\na:hover {\n   color: #ffa726;\n}\ni {\n   display: block;\n   line-height: 20px;\n   width: 20px;\n   height: 20px;\n   text-align: center;\n   transition: transform .3s;\n   position: absolute;\n   top: 0;\n   left: 0;\n}\ni.fa-spinner {\n   left: -1px;\n}\nimg {\n   display: block;\n   width: 20px;\n   height: 20px;\n   position: absolute;\n   top: 0;\n   left: -25px;\n}\n.expanded {\n   transform: rotate(90deg);\n}\n.error {\n   margin-left: 8px;\n   margin-top: 5px;\n}\n\napp-folders,\napp-one-drive-folders,\napp-google-drive-folders,\napp-dropbox-folders{\n   display: block;\n   margin-left: 16px;\n}\n\na.selectedPath {\n   color: #00bed6;\n}\na.denied {\n   cursor: default;\n   color: #a7a6a6;\n   text-decoration: none;\n}\n.denied img {\n   filter: grayscale(100%);\n   opacity: .8;\n}\n.cannot{\n   color: #a7a6a6;\n   cursor:default;\n   text-decoration:none;\n}\n.cannot:hover{\n   color: #a7a6a6!important;\n   text-decoration:none;\n}\n.marginFolder{\n   margin-left:20px!important;\n}\n.checkBox{\n   width: 5px;\n   margin-left: 5px\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
